// Module
var code = "<cjs-file-picker ref=\"fileListPicker\"></cjs-file-picker>\n\n<div class=\"overflow-auto list-container h-100\">\n    <ul ref=\"fileList\" class=\"list-group\"></ul>\n</div>";
// Exports
module.exports = code;